import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { formatPartialDate } from 'Utility/date';

const UHDRSIndependenceScale = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id="functionalPerformance.uhdrsIndependenceScale" />}
    newButton={
      <DocumentCreationButton
        name="uhdrsIndependenceScale"
        text="functionalPerformance.newUhdrsIndependenceScale"
        onClick={startEdit({}, 'uhdrsIndependenceScale')}
        width={20}
        height={3}
        fontSize={14}
        alternate={true}
      />
    }
  >
    <HistoryRowListing
      documents={documents}
      headers={
        <>
          <Item xs={2}>
            <FormattedMessage id="general.date" />
          </Item>
          <Item xs={7}>
            <FormattedMessage id="functionalPerformance.uhdrsIndependenceScale" />
          </Item>
        </>
      }
      contentFormat={d => (
        <>
          <Item xs={2}>{formatPartialDate(d.date)}</Item>
          <Item xs={7}>
            {d.value ? (
              <>
                {d.value + ': '}
                <FormattedMessage id={`functionalPerformance.opts.uhdrsIndependenceScale.${d.value}`} />
              </>
            ) : (
              '-'
            )}
          </Item>
          <Item xs={3}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </Item>
        </>
      )}
    />
  </HistorySection>
);

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'uhdrsIndependenceScale'>>;
  startEdit: StartEdit;
  view?: IView;
}

export default UHDRSIndependenceScale;
